<script>
export default {
    name: "ConsultantDashBoard",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <div class="flex flex-wrap">
                <div class="w-full p-1 my-1 text-center text-white bg-blue-500 rounded">
                    <h5 class="font-medium text-base">Consultant Payment Dashboard</h5>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-blue-100 border-b-4 border-blue-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `billing.consultant-dashboard.define-payment.create`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-blue-600">
                                        <i class="fas fa-plus fa-2x fa-inverse"></i>
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Define Consultant Payment</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-orange-100 border-b-4 border-orange-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `billing.consultant-dashboard.payment.create`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-orange-600">
                                        <i class="fas fa-hand-holding-usd fa-2x fa-inverse"></i>
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Consultant Payment</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-indigo-100 border-b-4 border-indigo-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `billing.consultant-dashboard.payment.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-indigo-600">
                                        <i class="fas fa-eye fa-2x fa-inverse"></i>
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">View Consultants Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/4 xl:w-1/4 p-2">
                    <div class="bg-red-100 border-b-4 border-red-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `billing.consultant-dashboard.payment.reverse.create` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-5 bg-red-600">
                                        <i class="fas fa-undo fa-2x fa-inverse"></i>
                                    </div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Reverse Consultants Payments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
    </tail-base-layout>
</template>
